<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RealEstateFinancePaymentResponsibilityRow from './RealEstateFinancePaymentResponsibilityRow.vue';

const props = defineProps({
  loading: { type: Boolean, default: false },
  responsibilities: { type: Array, default: () => [] },
  role: { type: String, required: true },
});

const emit = defineEmits(['boleto', 'payment']);
const { t } = useI18n();
const rows = computed(() =>
  props.responsibilities.filter(
    responsibility => responsibility.papel === props.role
  )
);
</script>

<template>
  <div class="contents">
    <div
      v-if="rows.length"
      data-payment-responsibility-group
      class="rounded-lais border border-lais-border-soft p-4"
    >
      <div
        class="hidden grid-cols-[minmax(10rem,2fr)_minmax(9rem,1fr)_minmax(7rem,1fr)_minmax(7rem,1fr)_minmax(8rem,1fr)_minmax(9rem,1fr)_auto] gap-3 border-b border-lais-border-soft pb-4 text-xs font-bold uppercase tracking-wide text-lais-text-muted sm:grid"
      >
        <span class="text-lais-text">{{ role }}</span>
        <span>{{ t('REAL_ESTATE_FINANCE.DETAIL.PAYMENT_STATUS') }}</span>
        <span>{{ t('REAL_ESTATE_FINANCE.DETAIL.SENT_ON') }}</span>
        <span>{{ t('REAL_ESTATE_FINANCE.DETAIL.DUE_ON') }}</span>
        <span>{{ t('REAL_ESTATE_FINANCE.DETAIL.BOLETO_VALUE') }}</span>
        <span>{{ t('REAL_ESTATE_FINANCE.DETAIL.FILE') }}</span>
        <span>{{ t('REAL_ESTATE_FINANCE.DETAIL.PAID') }}</span>
      </div>
      <p class="text-sm font-bold text-lais-text sm:hidden">{{ role }}</p>
      <div class="mt-4 divide-y divide-lais-border-soft sm:mt-0">
        <RealEstateFinancePaymentResponsibilityRow
          v-for="responsibility in rows"
          :key="responsibility.id"
          :loading="loading"
          :responsibility="responsibility"
          @boleto="emit('boleto', $event)"
          @payment="emit('payment', $event)"
        />
      </div>
    </div>
  </div>
</template>
